import moment from 'moment';

const TYPES = {
    Resource: 1,
    Blueprint: 2,
    Endo: 3,
    Credits: 4,
    Aura: 5
}

export default class Alert {
    constructor(rss) {
        if(rss) {
            this.guid = rss.guid;
            this.description = rss.description;
            this.title = rss.title;
            this.pubDate = rss.pubDate;
            this.rss = rss;
            this.pubDate = rss.pubDate;
            this.unread = false;
            let tmp = rss.title.split(' - ');
            if(tmp.length === 4) {
                this.drop = tmp[0];
                this.credits = tmp[1];
                this.location = tmp[2];
                this.timeToExpires = tmp[3];
            } else if(tmp.length === 3) {
                this.credits = tmp[0];
                this.location = tmp[1];
                this.timeToExpires = tmp[2];
            }
            this.credits = this.credits.replace('cr','');
        }
    }

    getExpires() {
        let expireDate = moment(this.pubDate).add(this.timeToExpires.replace('m',''),'minute');
        return expireDate.diff(moment(), 'minutes');
    }

    hasExpired() {
        // console.log('item: '+this.drop + ' expires'+moment(this.pubDate).add(this.timeToExpires.replace('m',''),'minute').format());
        return moment(this.pubDate).add(this.timeToExpires.replace('m',''),'minute').isBefore(moment());
    }

    getImg() {
        if(this.getType() === TYPES.Endo)
            return 'endo.png';
        if(this.getType() === TYPES.Credits)
            return 'credits.png';
        if(this.getType() === TYPES.Blueprint)
            return 'blueprint.png';
        if(this.getType() === TYPES.Resource)
            return 'resources.png';
        return 'LotusFlower.png';
    }

    getWikiaLink() {
        let wikiaLink = 'http://warframe.wikia.com/wiki/';
        // if(this.getType() === TYPES.Resource) {
        //     let tmp = this.drop.split(' ');
        //     tmp.pop();
        //     wikiaLink += tmp.join(' ');
        //     // let tmp = this.drop.split(' ');
        //     // if(tmp.length === 2) {
        //     //     wikiaLink += tmp[0];
        //     // }
        //     // else if(tmp.length > 3) {
        //     //     wikiaLink += tmp[1] + ' ' + tmp[2];
        //     // } else
        //     //     wikiaLink += tmp[1];
        // }

        wikiaLink += this.drop.replace(/\([\w]+\)|[0-9]+x+/g,'');

        return encodeURI(wikiaLink);
    }

    getType() {
        if(this.drop && this.drop.indexOf('(Blueprint)') > -1)
            return TYPES.Blueprint;
        if(this.drop && this.drop.indexOf('(Resource)') > -1)
            return TYPES.Resource;
        if(this.drop && this.drop.indexOf('ENDO') > -1)
            return TYPES.Endo;
        if(this.drop && this.drop.indexOf('(Aura)') > -1)
            return TYPES.Aura;
        if(!this.drop)
            return TYPES.Credits;
    }
}


// WEBPACK FOOTER //
// ./src/classes/alert.js